export const places = [
  { name: 'Healthcare', rate: 2500, size: 10000 },
  { name: 'Office', rate: 2750, size: 5000 },
  { name: 'Restaurant', rate: 2250, size: 3000 },
  { name: 'Other', rate: 3250, size: 15700 }
]

export default places
